import * as React from 'react';
import clsx from 'clsx';

import { FormParserContext } from 'src/contexts/form.context';
import { render, renderWithIndex } from 'src/tools/render.tools';
import { Checkbox } from 'src/components/Checkbox';
import { ButtonBaseType, ID } from 'src/models/general.model';
import { CONFIG } from 'src/config';

import classes from './CheckboxGroup.module.scss';

export function CheckboxGroup() {
  const { value, script, onChange } = React.useContext(FormParserContext);

  const checkboxGroups = React.useMemo(() => {
    const result = [];

    let currentSection: ButtonBaseType[] = [];

    script.items?.forEach(i => {
      currentSection.push(i);

      if (currentSection.length === CONFIG.checkboxGroup.maxItemsInGroup) {
        result.push(currentSection);
        currentSection = [];
      }
    });

    if (currentSection.length) result.push(currentSection);

    return result;
  }, [script.items]);

  function handleOnChange(id: ID) {
    return function call() {
      const oldValue: string[] = value ?? script.defaultValue ?? [];

      onChange(oldValue.includes(String(id)) ? oldValue.filter(i => i !== id) : [...oldValue, id]);
    };
  }

  function renderCheckbox(item: ButtonBaseType) {
    return (
      <Checkbox
        key={item.id}
        label={item.label}
        isChecked={(value ?? script.defaultValue).includes(item.id)}
        isDisabled={item.isDisabled}
        onClick={handleOnChange(item.id)}
      />
    );
  }

  function renderCheckboxGroup(items: ButtonBaseType[], index: number) {
    return (
      <div key={index} className={clsx(classes.grid, classes[script.customization || ''])}>
        {render(items, renderCheckbox)}
      </div>
    );
  }

  return <div className='column items-4'>{renderWithIndex(checkboxGroups, renderCheckboxGroup)}</div>;
}
